import styled from '@emotion/styled';
import css from '@emotion/css';
import { borderRadii } from 'app/spacing';
import CheckboxGroup from '__components/Inputs/CheckboxGroup';
import Button from '__components/Button';
import IconButton from '__components/Kizen/IconButton';

export const StyledCheckboxGroupOuter = styled.div<{ expanded: boolean }>`
  display: grid;
  transition: grid-template-rows 0.3s ease;
  ${({ expanded }) =>
    expanded
      ? css`
          grid-template-rows: 1fr;
        `
      : css`
          grid-template-rows: 0fr;
          pointer-events: none;
        `}
  margin-bottom: 15px;
  margin-left: 27px;
  /*  In case of long names we need to restrict the width to have enough space for right column tables */
  max-width: min(calc(50vw - 143px), calc(100vw - 728px), 604px);
`;

export const StyledCheckboxGroup = styled(CheckboxGroup)`
  min-height: 0;
  overflow: hidden;
`;

export const StyledCheckAllWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const StyledRotatingIconButton = styled(IconButton)<{
  expanded: boolean;
}>`
  transition: transform 0.3s ease;
  ${({ expanded }) => css`
    transform: rotate(${expanded ? 0 : 90}deg);
  `};
`;

export const StyledLinkWrapper = styled.div`
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
`;

export const StyledTableWrapper = styled.div`
  border: 1px solid var(--color-border-medium);
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  height: 496px;
  > div {
    height: 100%;
  }
`;

export const StyledPaginationWrapper = styled.div`
  margin-top: 20px;
`;

export const StyledButton = styled(Button)`
  margin: 0;
`;

export const StyledUploadButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
`;

export const StyledCardToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0;
  margin: 20px 0 6px;

  & h3 {
    line-height: 1;
  }

  & button {
    margin: 0;
    padding-right: 0;
    height: fit-content;
  }
`;
